import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";

import img1 from "../../assets/Images/Home/WhatsApp Image 2025-06-17 at 14.49.04.jpeg";
import img2 from "../../assets/Images/Home/Gemini_Generated_Image_xkz6v6xkz6v6xkz6.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function Projects() {
  const isMobile = useIsMobile();
  const [hoveredProject, setHoveredProject] = useState(null);

  const ProjectPanel = ({ index, image, title, description }) => (
    <div
      onMouseEnter={() => setHoveredProject(index)}
      onMouseLeave={() => setHoveredProject(null)}
      className="image-container"
      style={{
        height: isMobile ? "400px" : "690px",
        cursor: "pointer",
      }}
    >
      {/* Image */}
      <img
        className="image-cover-full-responsive"
        src={image}
        alt={`blog-${index}`}
        style={{
          transition: "transform 0.5s ease",
          transform: hoveredProject === index ? "scale(1.05)" : "scale(1)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor:
            hoveredProject === index
              ? "rgba(0, 0, 0, 0.3)"
              : "rgba(0, 0, 0, 0.5)",
          transition: "all 0.5s ease",
        }}
      />
      <div
        className="project-content"
        style={{
          position: "absolute",
          top: "50%",
          left: "10%",
          right: "10%",
          transform: `translate(0, ${
            hoveredProject === index ? "-60%" : "-50%"
          })`,
          transition: "all 0.5s ease",
          color: "white",
          textAlign: "center",
          fontFamily: "BodoniModa_18pt",
        }}
      >
        <div
          style={{
            transition: "all 0.5s ease",
            opacity: hoveredProject === index ? 1 : 0.8,
            transform:
              hoveredProject === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <h4 className="heading-sm m-0">{title}</h4>
        </div>
        <div
          style={{
            marginTop: "10px",
            transition: "all 0.5s ease",
            opacity: hoveredProject === index ? 1 : 0.8,
            transform:
              hoveredProject === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <p className="body-md">{description}</p>
        </div>
        <Button
          className="rounded-0 text-uppercase"
          variant="outline-light"
          disabled
          style={{
            fontSize: isMobile ? "18px" : "28px",
            fontFamily: "BodoniModa_18pt",
            width: isMobile ? "100%" : "80%",
            transition: "all 0.5s ease",
            transform:
              hoveredProject === index ? "translateY(-10px)" : "translateY(0)",
            opacity: 0.8,
            cursor: "default",
          }}
        >
          Coming Soon
        </Button>
      </div>
    </div>
  );

  return (
    <Container fluid className="p-0">
      {/* Top header row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}
        {!isMobile && (
          <div
            style={{
              width: "30%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}
        <div
          style={{
            width: isMobile ? "100%" : "30%",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0 text-center">PROJECTS.</h3>
          </div>
        </div>
        {!isMobile && (
          <div style={{ width: "30%", borderBottom: "1px solid black" }} />
        )}
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
            }}
          />
        )}
      </div>

      {/* Panel row */}
      <div
        className="d-flex justify-content-center"
        style={{ flexDirection: isMobile ? "column" : "row" }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
        )}

        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            padding: "0",
          }}
        >
          <ProjectPanel
            index={1}
            image={img1}
            title="MID CENTURY HAVEN"
            description="A Mid-Century Modern haven with clean lines, organic forms, and timeless textures. Warm woods, iconic silhouettes, and a muted palette evoke nostalgia and serenity..."
          />
        </div>

        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            padding: "0",
          }}
        >
          <ProjectPanel
            index={2}
            image={img2}
            title="VICTORIAN HOME"
            description="A charming Victorian home filled with character—ornate details, vintage accents, and timeless craftsmanship evoke a romantic elegance from a bygone era..."
          />
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
            }}
          />
        )}
      </div>

      {/* Hidden row for layout symmetry */}
      {!isMobile && (
        <div className="d-flex justify-content-center ">
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
          <div
            style={{
              width: "30%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          />
          <div
            style={{
              width: "30%",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <h3
                className="heading-sm m-0"
                style={{
                  visibility: "hidden",
                }}
              >
                PROJECTS.
              </h3>
            </div>
          </div>
          <div style={{ width: "30%", borderBottom: "1px solid black" }} />
          <div
            style={{
              width: "5%",
              borderBottom: "1px solid black",
              borderLeft: "1px solid black",
            }}
          />
        </div>
      )}
    </Container>
  );
}
